// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"_2NU4jCzkeEf1OQepKfUpxl","tableWrapperResponsive":"K5_qRABXL9UoEg7L3X_Hm"};